import {Button, Modal, Typography} from "antd";
import React, {useEffect, useMemo, useState} from "react";
import {
    Body,
    CancelButton,
    Center,
    CloseButton,
    Content,
    Footer,
    Header,
    PrimaryButton,
    Right,
    SecondaryButton,
    Title
} from "./styles";
import useMemoizedFn from "../../../hook/useMemoizedFn";
import TTLCounter from "../../../rebate/component/Activation/TTLCounter";
import {CloseOutlined} from "@ant-design/icons";

export interface AutoCloseOptions {
    timeout: number
}

interface NotifyModalProps {
    open: boolean;
    autoClose: AutoCloseOptions;
    close: () => void;
}
function NotifyModal(props: NotifyModalProps) {

    const {
        open,
        autoClose,
        close: _close
    } = props;

    const [ttl, setTtl] = useState<number | null>(null);
    const ttlCounter = useMemo(() => {
        return new TTLCounter(autoClose.timeout, (ttl: number) => {
            setTtl(ttl);
        })
    }, [autoClose.timeout]);

    const close = useMemoizedFn(_close);
    useEffect(() => {
        if (open) {
            ttlCounter.start();
        }
        return () => {
            ttlCounter.reset();
        }
    }, [ttlCounter, open]);

    useEffect(() => {
        if (ttl === 0) {
            close();
        }
    }, [ttl, close]);
    return  <Modal
        open={open}
        onCancel={() => {
            close();
        }}
        footer={null}
        bodyStyle={{padding: 0}}
        closable={false}
    >
        <Header>
            <Right>
                {ttl}秒后将自动关闭
                <CloseButton onClick={() => {
                    close();
                }}>
                    <span className={"ant-modal-close-x"}>
                        <CloseOutlined />
                    </span>
                </CloseButton>
            </Right>

        </Header>
        <Body>
            <Title>
                牛X神仙道平台十二年庆典-充值返利100%-150%
            </Title>
            <Content>
                平台通用福利: <br />
                1. 平台币充值返利<Typography.Text type={"danger"}>白动秒到账，永久100%返利(任总金额)</Typography.Text> <br />
                2. <Typography.Text type={"danger"}>激活白名单</Typography.Text>后充值和返利会按照<Typography.Text type={"danger"}>平台币</Typography.Text>方式体现 <br />
                新区首日福利:<br />
                1. <Typography.Text type={"danger"}>新区首日累计充值100元=230平台币=2300元宝</Typography.Text><br />
                2. 更多首日福利联系 <Typography.Text type={"danger"}>客服微信: xiaozha80</Typography.Text><br />
            </Content>
        </Body>
        <Footer>
            <Center>
                <PrimaryButton type={"primary"} onClick={() => {
                    window.open(`https://niu.niuxyx.com/game/000054/rebate.html`)
                }}>
                    激活百返名单
                </PrimaryButton>
                <div>
                <SecondaryButton style={{
                    color: "#ff4d4f",
                }} type={"link"}  onClick={() => {
                    window.open(`https://niu.niuxyx.com/game/000054/rebate.html`)
                }}>
                    进新区找客服领&lt;继承码&gt;
                </SecondaryButton>
                </div>
            </Center>


            <CancelButton type={"link"} onClick={() => {
                close();
            }}>
                直接进入游戏 &gt;
            </CancelButton>
        </Footer>


    </Modal>
}

export default NotifyModal;